import { ProjectsContext } from "App";
import { onReturnKey } from "lib/helpers";
import { useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

export default function Create() {
  const title = useRef();
  const projects = useContext(ProjectsContext);
  const history = useHistory();
  function submit() {
    projects.add({ name: title.current.value });
    history.replace("/");
  }
  function onKeyDown(e) {
    onReturnKey(submit)(e);
  }
  useEffect(() => {
    title.current.focus();
  }, []);
  return (
    <div className="hm">
      <div className="cr">
        <div className="cr-c">
          <div className="cr-b">
            <div>
              <h1>Create new project</h1>
            </div>
            <div>
              <input
                type="text"
                ref={title}
                placeholder="Title..."
                {...{ onKeyDown }}
              />
            </div>
          </div>
          <div className="cr-t">
            <button onClick={submit}>Create</button>
          </div>
        </div>
      </div>
    </div>
  );
}
